import Vue from 'vue'
import App from './App.vue'

import Antd from 'ant-design-vue';
Vue.use(Antd);
import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
